"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightsOnWeekTabs = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("../../Button");
const FlightTab_1 = require("../../Placeholder/FlightTab");
const Flight_1 = require("../Flight");
require("./index.scss");
const className = 'select-flight-form';
const FlightsOnWeekTabs = (props) => {
    const { isSubmitButtonDisabled, activeTab, airportsFromToText, flightLoading, flightTabs, submitButtonText, onSubmit, notShowSubmitButton = false, modificators, } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        flightLoading && (react_1.default.createElement(FlightTab_1.PlaceholderFlightTab, null)),
        !flightLoading && flightTabs && (react_1.default.createElement(Flight_1.ReservationFlight, { activeTab: activeTab, tabs: flightTabs, text: airportsFromToText, modificators: modificators })),
        !notShowSubmitButton && (react_1.default.createElement("div", { className: `${className}__button` },
            react_1.default.createElement(Button_1.Button, { disabled: isSubmitButtonDisabled, icon: 'airplane', onClick: onSubmit, text: submitButtonText })))));
};
exports.FlightsOnWeekTabs = FlightsOnWeekTabs;
//# sourceMappingURL=index.js.map